import { useConfig } from "../ConfigContext";

export default function CaseDisplay({ caseData }) {
  const {config, error: configError } = useConfig();
  let totalFee = caseData.apt_Fine_apt_Case_apt_Case.reduce(
    (previousValue, currentValue) => previousValue + currentValue.apt_adjustedamount,
    0
  );

  const locationTypeInPerson = 750250000
  const locationTypeVirtual = 750250001;
  const offenceFineType = 750290000;
  let offenceFine = caseData.apt_Fine_apt_Case_apt_Case.find(fine => fine.apt_type === offenceFineType);
  let otherFines = caseData.apt_Fine_apt_Case_apt_Case.filter(fine => fine.apt_type !== offenceFineType);

  const downloadFile = (event) => {
    event.preventDefault();
    const fileId = event.target.getAttribute("data-file-id");
    fetch(`${config.apiUrl}/cases/${caseData.apt_caseid}/file-url/${fileId}`, {
      headers: {
        "Api-Key": config.apiKey,
      },
    })
      .then((response) => {
        if (response.status === 200) return response.json();
      })
      .then((responseJson) => {
        setTimeout(() => {
          window.open(responseJson.downloadUrl, '_blank');
        });
      });
  };

  const now = new Date();
  let openAppointment = caseData.apt_HearingRequest ? caseData.apt_HearingRequest.apt_appointment_Review_apt_review.find(app => (new Date(app.scheduledstart)) >= now) : caseData.apt_ScreeningRequest ? caseData.apt_ScreeningRequest.apt_appointment_Review_apt_review.find(app => (new Date(app.scheduledstart)) >= now) : null;
  let openAppointmentStart = openAppointment ? new Date(openAppointment['scheduledstart']) : null;
  let openAppointmentEnd = openAppointment ? new Date(openAppointment['scheduledend']) : null;

  const createDownloadICS = () => {
    const now = new Date();
    const text = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//york.ca/
CALSCALE:GREGORIAN
BEGIN:VEVENT
UID:${openAppointment['activityid']}
DTSTAMP:${now.getUTCFullYear()}${(now.getUTCMonth()+1).toString().padStart(2,'0')}${now.getUTCDate()}T${now.getUTCHours().toString().padStart(2,'0')}${now.getUTCMinutes().toString().padStart(2,'0')}00Z
DTSTART:${openAppointmentStart.getUTCFullYear()}${(openAppointmentStart.getUTCMonth()+1).toString().padStart(2,'0')}${openAppointmentStart.getUTCDate()}T${openAppointmentStart.getUTCHours().toString().padStart(2,'0')}${openAppointmentStart.getUTCMinutes().toString().padStart(2,'0')}00Z
DTEND:${openAppointmentEnd.getUTCFullYear()}${(openAppointmentEnd.getUTCMonth()+1).toString().padStart(2,'0')}${openAppointmentEnd.getUTCDate()}T${openAppointmentEnd.getUTCHours().toString().padStart(2,'0')}${openAppointmentEnd.getUTCMinutes().toString().padStart(2,'0')}00Z
SUMMARY:Penalty Order ${openAppointment['app_service@OData.Community.Display.V1.FormattedValue']} Appointment
DESCRIPTION:York Region Penalty Order Appointment\\n\\n${openAppointment['app_service@OData.Community.Display.V1.FormattedValue']} for penalty order #${caseData['apt_number']}\\n\\n${openAppointment['app_locationtype'] === locationTypeVirtual ? `Join Meeting by Phone\\n${openAppointment['app_phonenumber']}\\nConference Id\\n${openAppointment['app_conferenceid']}\\n\\nOr Join Virtually Using Microsoft Teams\\n${openAppointment["onlinemeetingjoinurl"]}` : 'Please proceed to the APT counter located on the 2nd floor.'}
LOCATION:${openAppointment['app_locationtype'] === locationTypeInPerson ? '17150 Yonge St. Newmarket' : 'Phone / Virtual'}
URL:${openAppointment['app_locationtype'] === locationTypeInPerson ? 'https://goo.gl/maps/gVmVLvejHvrEQTz19' : openAppointment['onlinemeetingjoinurl']}
END:VEVENT
END:VCALENDAR`;
    const link = document.createElement("a");
    link.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(text));
    link.download = "invite.ics";
    link.click();
    URL.revokeObjectURL(link.href);
 };

 const paymentDueDate = new Date(caseData['apt_currentpaymentduedate']);
 const downloadPaymentReminder = () => {
  const now = new Date();
    const text = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//york.ca/
CALSCALE:GREGORIAN
BEGIN:VEVENT
UID:${caseData['apt_caseid']}
DTSTAMP:${now.getUTCFullYear()}${(now.getUTCMonth()+1).toString().padStart(2,'0')}${now.getUTCDate()}T${now.getUTCHours().toString().padStart(2,'0')}${now.getUTCMinutes().toString().padStart(2,'0')}00Z
DTSTART:${paymentDueDate.getUTCFullYear()}${(paymentDueDate.getUTCMonth()+1).toString().padStart(2,'0')}${paymentDueDate.getUTCDate()}T150000Z
DTEND:${paymentDueDate.getUTCFullYear()}${(paymentDueDate.getUTCMonth()+1).toString().padStart(2,'0')}${paymentDueDate.getUTCDate()}T150000Z
SUMMARY:Penalty Order Payment Due
DESCRIPTION:York Region Penalty Order Payment Due\\n\\nPlease visit ${window.location.origin}${window.location.pathname}
URL:${window.location.origin}${window.location.pathname}?case-num=${caseData['apt_number']}
END:VEVENT
END:VCALENDAR`;
    const link = document.createElement("a");
    link.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(text));
    link.download = "reminder.ics";
    link.click();
    URL.revokeObjectURL(link.href);
 }

//  TODO: Pull out into separate component
  const displayReceipt = (event) => {
    event.preventDefault();
    const paymentId = event.target.getAttribute("data-payment-id");
    const payment = caseData.apt_Payment_apt_Case_apt_Case.find(payment => payment.apt_paymentid === paymentId);
    var newWindow = window.open();
    newWindow.document.write(`
    <html>
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
    </head>
    <body style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; margin: 0;">
        <table class="receipt" width="350" style="background-color: #fff; border-radius: 8px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); margin: 2rem; border-collapse: collapse;">
            <tr>
                <td class="header" style="text-align: center; padding: 20px; background-color: #e6e6e6;">
                    <img src="https://www.york.ca/themes/custom/york_base_theme/src/img/print/logo--york--print.svg" alt="Company Logo" style="max-width: 150px; max-height: 60px; margin-bottom: 10px;"/>
                    <p>
                        Regional Municipality of York
                        <br/>17150 Yonge Street
                        <br/>Newmarket ON
                        <br/>L3Y 8V3
                        <br/>apt@york.ca
                        <br/>1-888-448-0000
                    </p>
                    <h2>${payment.apt_transactionresult === 750290000 ? 'Payment Receipt' : 'Payment DECLINED'}</h2>
                </td>
            </tr>

            <tr>
                <td class="middle-section" style="padding: 10px; padding-top:20px; padding-bottom:20px; color: #333;">
                    <p>
                        Receipt Date: ${payment['createdon@OData.Community.Display.V1.FormattedValue']}
                        <br/>Receipt Number: ${payment.apt_number}
                        <br/>Penalty Order #: ${caseData.apt_number}
                        <br/>${payment.apt_transactionresult === 750290000 ? 'Total Paid' : 'Declined Amount'}: ${payment['apt_amount@OData.Community.Display.V1.FormattedValue']}
                        ${payment['apt_cashreceived'] ? `<br/>Cash Received: ${payment['apt_cashreceived@OData.Community.Display.V1.FormattedValue']}` : ''}
                        ${payment['apt_changegiven'] ? `<br/>Change Given: ${payment['apt_changegiven@OData.Community.Display.V1.FormattedValue']}` : ''}
                    </p>
                    ${caseData.apt_totalpayable === 0 ? '<p>This penalty order has been paid in full and is now closed</p>' : `<p>This penalty order remains open. Outstanding balance: ${caseData['apt_totalpayable@OData.Community.Display.V1.FormattedValue']}</p>`}
                </td>
            </tr>

            <tr>
                <td class="separator" style="border-top: 1px solid #ddd;"></td>
            </tr>

            <tr>
                <td class="payment-info" style="padding: 10px; padding-top:20px; padding-bottom:20px; ">
                    <p>
                        Transaction Information
                        <br/>Type: ${payment['apt_method@OData.Community.Display.V1.FormattedValue']}
                        ${payment['apt_transactioncardtype'] ? `<br/>Card Type: ${payment['apt_transactioncardtype@OData.Community.Display.V1.FormattedValue']}` : ''}
                        ${payment['apt_creditcardlastfourdigits'] ? `<br/>Card Number: **** **** **** ${payment['apt_creditcardlastfourdigits']}` : ''}
                        ${payment['apt_transactionordernumber'] ? `<br/>Payment Confirmation Number: ${payment['apt_transactionordernumber']}` : ''}
                    </p>
                </td>
            </tr>

            <tr>
                <td class="thank-you" style="text-align: center; padding: 10px; padding-top:20px; padding-bottom:20px; background-color: #e6e6e6;">
                    <p>
                        ${payment.apt_transactionresult === 750290000 ? 'Thank you for your payment' : 'This payment has been declined'}
                        ${payment.apt_transactionresult === 750290000 ? '' : '<br/>Please try again or contact us at 1-888-448-0000'}
                    </p>
                </td>
            </tr>
        </table>
    </body>
    </html>
    `);
    newWindow.document.close();
  }

  return (
    <div>
      
        <div className="display-only-item--inline">
          <label>Penalty Type:</label>
          <div className="value">
            {caseData["apt_type@OData.Community.Display.V1.FormattedValue"]}
          </div>
        </div>

        <div className="display-only-item--inline">
          <label>Status:</label>
          <div className="value">
            {
              caseData[
                "apt_casestatus@OData.Community.Display.V1.FormattedValue"
              ]
            }
          </div>
        </div>

        <div className="display-only-item--inline">
          <label>Deemed Service Date:</label>
          <div className="value">
            {config.dateFormatter.format(
              new Date(
                caseData[
                  "apt_deemedservicedate"
                ]
              )
            )}
          </div>
        </div>

        <div className="display-only-item--inline">
          <label>License Plate Number:</label>
          <div className="value">
            {caseData.apt_Recipient.apt_licenseplatenumber}
          </div>
        </div>

        <div className="display-only-item--inline">
          <label>Name:</label>
          <div className="value">
            {caseData.apt_Recipient.firstname} {caseData.apt_Recipient.lastname}
          </div>
        </div>

        <div className="display-only-item">
          <label>Address</label>
          <div className="value">
            {caseData.apt_Recipient.address1_line1}
            <br/>{caseData.apt_Recipient.address1_city}, {caseData.apt_Recipient.address1_stateorprovince}
            <br/>{caseData.apt_Recipient.address1_postalcode}
          </div>
        </div>

        <br />

        {openAppointment && (
          <>
          <div className="review-appointment">
            <div className="js-form-item form-item">
              <label>Upcoming Appointment</label>
              <div className="flex-container cal-container">
                <div className="cal" style={{ marginRight: "10px" }}>
                  <div className="month">
                    {openAppointmentStart.toLocaleString("en-US", {
                      month: "short",
                    })}
                  </div>
                  <div className="date">{openAppointmentStart.getDate()}</div>
                  <div className="day">
                    {openAppointmentStart.toLocaleString("en-US", {
                      weekday: "long",
                    })}
                  </div>
                </div>
                <div className="cal">
                  <div className="time">
                    {openAppointmentStart.toLocaleString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </div>
                </div>
              </div>
              {openAppointment["app_locationtype"] === locationTypeInPerson && (
                <div className="value">
                  Location: 17150 Yonge St. Newmarket, 2nd Floor APT Counter
                </div>
              )}
              {openAppointment["app_locationtype"] === locationTypeVirtual && (
                <>
                  <div className="value">
                    Join Meeting by Phone: {openAppointment["app_phonenumber"]}
                  </div>
                  <div className="value">
                    Conference Id: {openAppointment["app_conferenceid"]}
                  </div>
                  <div className="value">
                    <a href={openAppointment["onlinemeetingjoinurl"]}>
                      Or by Video Conference Join URL (Microsoft Teams)
                    </a>
                  </div>
                </>
              )}
              <div className="value">
                <span className="link" onClick={createDownloadICS}>
                  Download Invite
                </span>
              </div>
            </div>
          </div>
          <br/>
          </>
        )}

        {(caseData.apt_ExtensionRequest?.apt_result || caseData.apt_ExtensionRequest?.apt_cannedresult) && (
          <>
          <div className="review-decision">
            <label>Extension Decision Comments</label>
            <div className="display-only-item--inline">
              <label>Decision Date:</label>
              <div className="value">
                {
                  caseData.apt_ExtensionRequest[
                    "apt_decidedon@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </div>
            </div>
            <div className="display-only-item--inline">
              <label>Decision:</label>
              <div className="value">
                {caseData.apt_ExtensionRequest[
                    "apt_decision@OData.Community.Display.V1.FormattedValue"
                  ]}
              </div>
            </div>
            <div className="display-only-item">
              <label>Comments:</label>
              <div className="value">
                {caseData.apt_ExtensionRequest.apt_cannedresult} {(caseData.apt_ExtensionRequest.apt_cannedresult && caseData.apt_ExtensionRequest.apt_result) && <br/>}
                {caseData.apt_ExtensionRequest.apt_result}
              </div>
            </div>
            {caseData.apt_ExtensionRequest.apt_extensiondays > 0 && (
              <div className="display-only-item--inline">
                <label>Screening Extension Days:</label>
                <div className="value">
                  {caseData.apt_ExtensionRequest.apt_extensiondays}
                </div>
              </div>
            )}
          </div>
          <br/>
          </>
        )}

      {(caseData.apt_ScreeningRequest?.apt_result || caseData.apt_ScreeningRequest?.apt_cannedresult) && (
          <>
          <div className="review-decision">
            <label>Screening Review Decision</label>
            <div className="display-only-item--inline">
              <label>Decision Date:</label>
              <div className="value">
                {
                  caseData.apt_ScreeningRequest[
                    "apt_decidedon@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </div>
            </div>
            <div className="display-only-item--inline">
              <label>Decision:</label>
              <div className="value">
                {
                  caseData.apt_ScreeningRequest[
                    "apt_decision@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </div>
            </div>
            <div className="display-only-item">
              <label>Comments</label>
              <div className="value">
                {caseData.apt_ScreeningRequest.apt_cannedresult} {(caseData.apt_ScreeningRequest.apt_cannedresult && caseData.apt_ScreeningRequest.apt_result) && <br/>}
                {caseData.apt_ScreeningRequest.apt_result}
              </div>
            </div>
            {caseData.apt_ScreeningRequest.apt_newfineamount !== null && (
              <div className="display-only-item--inline">
                <label>Reduced Fine Amount:</label>
                <div className="value">
                  {config.currencyFormatter.format(
                    caseData.apt_ScreeningRequest.apt_newfineamount
                  )}
                </div>
              </div>
            )}
            {caseData.apt_ScreeningRequest.apt_paymentextensiondays > 0 && (
              <div className="display-only-item--inline">
                <label>Payment Extension Days:</label>
                <div className="value">
                  {caseData.apt_ScreeningRequest.apt_paymentextensiondays}
                </div>
              </div>
            )}
          </div>
          <br/>
          </>
        )}

        {(caseData.apt_HearingRequest?.apt_result || caseData.apt_HearingRequest?.apt_cannedresult) && (
          <>
          <div className="review-decision">
            <label>Hearing Review Decision</label>
            <div className="display-only-item--inline">
              <label>Decision Date:</label>
              <div className="value">
                {
                  caseData.apt_HearingRequest[
                    "apt_decidedon@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </div>
            </div>
            <div className="display-only-item--inline">
              <label>Decision:</label>
              <div className="value">
                {
                  caseData.apt_HearingRequest[
                    "apt_decision@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </div>
            </div>
            <div className="display-only-item">
              <label>Comments</label>
              <div className="value">
                {caseData.apt_HearingRequest.apt_cannedresult} {(caseData.apt_HearingRequest.apt_cannedresult && caseData.apt_HearingRequest.apt_result) && <br/>}
                {caseData.apt_HearingRequest.apt_result}
              </div>
            </div>
            {caseData.apt_HearingRequest.apt_newfineamount && (
              <div className="display-only-item--inline">
                <label>Reduced Fine Amount:</label>
                <div className="value">
                  {config.currencyFormatter.format(
                    caseData.apt_HearingRequest.apt_newfineamount
                  )}
                </div>
              </div>
            )}
            {caseData.apt_HearingRequest.apt_paymentextensiondays > 0 && (
              <div className="display-only-item--inline">
                <label>Payment Extension Days:</label>
                <div className="value">
                  {caseData.apt_HearingRequest.apt_paymentextensiondays}
                </div>
              </div>
            )}
          </div>
          <br/>
          </>
        )}

        <div className="display-only-item--inline">
          <label>Payment Due:</label>
          <div className="value">
            {config.dateFormatter.format(
              new Date(
                caseData[
                  "apt_currentpaymentduedate"
                ]
              )
            )}
            {new Date(caseData["apt_currentpaymentduedate"]) > new Date() && (
              <button
                className="cal-icon-small"
                title="Download Event as Reminder"
                onClick={downloadPaymentReminder}
              ></button>
            )}
          </div>
        </div>

        <div className="display-only-item--inline">
          <label>Total {offenceFine.apt_amountoverride ? "Reduced " : ""}Fine:</label>
          <div className="value">
            <strong>{config.currencyFormatter.format(totalFee)}</strong>
          </div>
        </div>

        <div className="display-only-item--inline">
          <div className="value">Includes&nbsp;
          {otherFines.map((fine) => (
            <>
              {config.currencyFormatter.format(fine.apt_adjustedamount)}{" "}
              {fine["apt_type@OData.Community.Display.V1.FormattedValue"]},&nbsp;
            </>
          ))}
          <>
            {config.currencyFormatter.format(
              offenceFine.apt_adjustedvictimsjusticefund
            )}{" "} Victims Component Fee, and&nbsp;
          </>
          <>
            {config.currencyFormatter.format(offenceFine.apt_mtoplatelookup)}{" "}
            Ministry of Transportation ARIS Fee
          </>
          </div>
        </div>

        <div className="display-only-item--inline">
          <label>Total Paid:</label>
          <div className="value">
            {config.currencyFormatter.format(caseData.apt_totalpayments)}
          </div>
        </div>

      {/* Plate Denial Notice */}
      {caseData.apt_casestatus === 750290009 && (
        <div className="plate-denial-notice" style={{background: '#fff3cd', border: '1px solid #ffeeba', color: '#644C04', padding: '16px', borderRadius: '6px', marginBottom: '20px'}}>
          <strong>Notice:</strong> Your case has been referred to plate denial with ServiceOntario due to non-payment.<br/>
          To resolve this matter, please attend the nearest <a href="https://www.ontario.ca/locations/serviceontario">ServiceOntario</a> location to make payment directly.
        </div>
      )}

        <br/> 

        <div className="js-form-item form-item">
          <label>Related Files</label>
          <div className="value">
            {caseData.apt_Document_apt_Case_apt_Case?.length > 0 ? (
              <ul>
                {caseData.apt_Document_apt_Case_apt_Case.map((doc) => (
                  <li key={doc.apt_documentid}>
                    {doc.apt_visibility === 750290001 ? (
                      <a
                        data-file-id={doc.apt_documentid}
                        href="#"
                        onClick={downloadFile}
                      >
                        { doc["apt_type@OData.Community.Display.V1.FormattedValue"] }
                      </a>
                    ) : (
                      <span>
                        { doc["apt_type@OData.Community.Display.V1.FormattedValue"] } (uploaded {doc["createdon@OData.Community.Display.V1.FormattedValue"]})
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <span>No files found for this case</span>
            )}
          </div>
        </div>

        <div className="js-form-item form-item">
          <label>
            Payment Receipt
            {caseData.apt_Payment_apt_Case_apt_Case?.length > 1 ? "s" : ""}
          </label>
          <div className="value">
            {caseData.apt_Payment_apt_Case_apt_Case?.length > 0 ? (
              <ul>
                {caseData.apt_Payment_apt_Case_apt_Case
                  .sort((a, b) => {
                    if (a.createdon > b.createdon) return -1;
                    else if (a.createdon < b.createdon) return 1;
                    else return 0;
                  })
                  .map((payment) => (
                    <li key={payment.apt_paymentid}>
                      <a
                        data-payment-id={payment.apt_paymentid}
                        href="#"
                        onClick={displayReceipt}
                      >
                        {
                          payment[
                            "apt_method@OData.Community.Display.V1.FormattedValue"
                          ]
                        }{" "}
                        (
                        {
                          payment[
                            "createdon@OData.Community.Display.V1.FormattedValue"
                          ]
                        }
                        )
                      </a>
                    </li>
                  ))}
              </ul>
            ) : (
              <span>No files found for this case</span>
            )}
          </div>
        </div>
      
    </div>
  );
}
